export const LOADING_BIENVENIDA = "LOADING_BIENVENIDA";
export const LOADING_BIENVENIDA_EMPLEADO = "LOADING_BIENVENIDA_EMPLEADO";
export const SAVE_LOADING_BIENVENIDA = "SAVE_LOADING_BIENVENIDA";
export const GET_BIENVENIDA = "GET_BIENVENIDA";
export const GET_BIENVENIDA_EMPLEADO = "GET_BIENVENIDA_EMPLEADO";
